import {configureClientAuthentication, OAuthClient} from '@alchemy/auth';
import {createHttpClient} from '@alchemy/api';
import {config} from '../config';
import axiosRetry, {isNetworkOrIdempotentRequestError} from 'axios-retry';
import {AxiosError} from 'axios';
import {topLevelDomain} from './urlHelper';
import {isInMobileApp} from './mobileAppBridge';
import {MobileAppOAuthClient} from './MobileAppOAuthClient';

const oauthBaseUrl = `${config.apiUrl}/oauth2`;
export const oauthHttpClient = createHttpClient(oauthBaseUrl);
const oauthClientOptions = {
    clientId: 'vkard_client',
    baseUrl: oauthBaseUrl,
    httpClient: oauthHttpClient,
};
// The app injects its bridge before any page script runs.
export const oauthClient = isInMobileApp()
    ? new MobileAppOAuthClient(oauthClientOptions)
    : new OAuthClient({
          ...oauthClientOptions,
          cookiesOptions: {
              domain: `.${topLevelDomain}`,
          },
          refreshTokenStorageKey: 'rt_' + topLevelDomain.replace('.', '_'),
      });

const apiClient = createHttpClient(config.apiUrl);

configureClientAuthentication(apiClient, oauthClient);

axiosRetry(apiClient, {
    retryCondition: (error: AxiosError) =>
        isNetworkOrIdempotentRequestError(error) &&
        ![500, 400, 422, 403, 401].includes(error.response?.status ?? 0),
});

export default apiClient;

export function setApiLocale(locale: string): void {
    if (import.meta.env.SSR) {
        return;
    }

    apiClient.setApiLocale(locale);
    oauthHttpClient.setApiLocale(locale);
}

export function getApiIdentity(prop: string | {id: string}): string {
    if (typeof prop === 'string') {
        return prop;
    }

    return prop.id;
}
